import { ReactNode, FunctionComponent, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { DefaultNavigationBar, Footer, NavigationVariantType } from '@restworld/ui-components';
import { cn, getAssetSrc } from '@restworld/utils-common';
import { useAuth } from '@restworld/feature-authentication';

export const LayoutWrapperOld: FunctionComponent<ILayoutWrapperProps> = ({
  children,
  title,
  hasFooter,
  hasNavbar,
  navbarVariant,
  showSearchBarInNavbar,
  isNavbarOffScreen,
}) => {
  const authContext = useAuth();
  const { isFallback } = useRouter();
  const [isNavOverlay, navOverlayToggler] = useState(false);

  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="shortcut icon" href={getAssetSrc('/utils-assets/favicons/favicon.ico')} />

        <title>{isFallback ? 'loading...' : title}</title>
      </Head>

      {hasNavbar ? (
        <NavigationContainer isOffScreen={isNavbarOffScreen}>
          <DefaultNavigationBar
            variant={navbarVariant}
            authProps={{
              ...{
                onLogout() {
                  authContext?.logout();
                },
                onStartSignup() {
                  /**To be implemented */
                },
                onStartLogin() {
                  /**To be implemented */
                },
              },
            }}
            showSearchBarInNavbar={showSearchBarInNavbar}
            isNavOverlay={isNavOverlay}
            navOverlayToggler={navOverlayToggler}
          />
        </NavigationContainer>
      ) : null}
      {children}
      {hasFooter ? <Footer /> : null}
    </>
  );
};

export interface ILayoutWrapperProps {
  title: string;
  children: ReactNode;
  hasFooter?: boolean;
  hasNavbar?: boolean;
  navbarVariant?: NavigationVariantType;
  showSearchBarInNavbar?: boolean;
  isNavbarOffScreen?: boolean;
  showLegacyLayout?: boolean;
  hideNavigation?: boolean;
}

const NavigationContainer = ({
  isOffScreen,
  className,
  ...props
}: { isOffScreen?: boolean } & React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'absolute top-0 w-full left-0 z-50 transition-all duration-500',
      isOffScreen ? 'top-[-1000px]' : '',
      className
    )}
    {...props}
  />
);
